import SelectDateComp from "../../components/delivery/SelectDate";

function SelectDate() {

  return (
    <SelectDateComp/>
  );
}

export default SelectDate;